import React from 'react';
import icon from '../images/icon-8.svg';

export const Contact = () => {
    return (
        <div className='contact' id="contact">
            <div className="icon">
                <img src={icon} alt="" />
            </div>
            <div
                className="container"
            >
                <h3
                // className="wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.2s"
                >Ready To <span>Grow Your Reach</span> ?</h3>
                <p
                    className='title'
                // className='title wow animate__animated animate__bounceInUp'
                // data-wow-duration="0.5s"
                // data-wow-delay="0.3s"
                >
                    Book your free call today—let’s turn views into leads and followers into paying clients.
                    <br />
                    Book your free discovery call now.
                </p>

                <div
                    className='calender'
                // className="calender wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.5s"
                >
                    {/* <InlineWidget
                        url="https://calendly.com/rohit-portkey/noam?ref=portkey.ai&month=2025-02"
                        className="frame"
                        styles={{ width: "100%", height: "700px" }}
                    /> */}

                    <div className="calendly-inline-widget" data-url="https://calendly.com/ajaysainisocial/1-1call"></div>
                    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
                </div>
            </div>
        </div>
    )
}
